import React, { useEffect, useState } from 'react';
import { Dropdown, Input, Typography, Toggle, colors } from '@cencosud-ds/bigbang';
import { BottomBar, FormSection, ToolTip } from '../../components';
import { IWizardFormProps } from '../../interfaces/wizard.interface';
import { useWizardFormControl } from '../../context';
import t from '../../../../../utils/translate';
import './index.css';
import { useFormik } from 'formik';
import validationSchema from './logistic.schema';
import { allowAlphanumeric, allowAplphabetic, allownumber, allowEmail } from 'utils/patterns';
import { trackGTMPageViewCuston } from 'utils/analytics';
import { getCommunesByRegionByGiv, getRegionsByGiv } from 'api/sellers';
import { Toast } from '@cencosud-ds/bigbang';

interface IDataDrop {
  value: string;
  label: string;
  children: string;
}

const LogisticStep: React.FC<IWizardFormProps> = props => {
  const { position } = props;

  const formWizard = useWizardFormControl(position);

  const formik = useFormik({
    initialValues: {
      addressWarehouse: formWizard.data.addressWarehouse ? formWizard.data.addressWarehouse : '',
      regionWarehouse: formWizard.data.regionWarehouse ? formWizard.data.regionWarehouse : '',
      communeWarehouse: formWizard.data.communeWarehouse ? formWizard.data.communeWarehouse : '',
      nameContact: formWizard.data.nameContact ? formWizard.data.nameContact : '',
      lastnameContact: formWizard.data.lastnameContact ? formWizard.data.lastnameContact : '',
      emailWarehouse: formWizard.data.emailWarehouse ? formWizard.data.emailWarehouse : '',
      emailConfirmWarehouse: formWizard.data.emailConfirmWarehouse ? formWizard.data.emailConfirmWarehouse : '',
      rolWarehouse: formWizard.data.rolWarehouse ? formWizard.data.rolWarehouse : '',
      phoneWarehouse: formWizard.data.phoneWarehouse ? formWizard.data.phoneWarehouse : '',
      technicalService: formWizard.data.technicalService ? formWizard.data.technicalService : false,
      nameNode: formWizard.data.nameNode ? formWizard.data.nameNode : '',
      numberNode: formWizard.data.numberNode ? formWizard.data.numberNode : '',
      nameRegion: formWizard.data.nameRegion ? formWizard.data.nameRegion : '',
      nameComune: formWizard.data.nameComune ? formWizard.data.nameComune : '',
    },
    onSubmit: values => {
      console.log(values);
    },
    validationSchema,
  });

  const [optionsCommune, setOptionsCommune] = useState<IDataDrop[]>([]);
  const [optionsRegions, setOptionsRegions] = useState<IDataDrop[]>([]);

  const getMessageTooltip = (message: string) => {
    return (
      <>
        <span className="font-message">{t(message)}</span>
      </>
    );
  };

  useEffect(() => {
    (async () => {
      const result = await getCommunesByRegionByGiv(formik.values.regionWarehouse);
      setOptionsCommune(result);
    })();
  }, [formik.values.regionWarehouse]);

  useEffect(() => {
    (async () => {
      const result = await getRegionsByGiv();
      setOptionsRegions(result);
    })();
  }, []);

  const setRegion = (region: string) => {
    if (region !== formik.values.regionWarehouse) {
      setOptionsCommune([]);
      formik.setFieldValue('regionWarehouse', region);
      const dataRegion = optionsRegions.find(item => item.value === region);
      if (dataRegion) {
        formik.setFieldValue('nameRegion', dataRegion.label);
      }
    }
  };

  const handleOnBack = () => {
    formWizard.data = formik.values;
  };

  const handleOnNext = async (): Promise<boolean> => {
    await formik.submitForm();
    const isFormValid = formik.isValid && Object.keys(formik.touched).length > 0;

    if (isFormValid) {
      formWizard.data = formik.values;
      return true;
    }
    return false;
  };

  useEffect(() => {
    trackGTMPageViewCuston({
      page: '/registrate-ahora',
      title: 'Información logística',
    });
  }, []);

  return (
    <>
      <div className="wizard-form-section pb-3">
        <div className="mb-5">
          <Typography
            typeElement="subtitle1"
            weight="semiBold"
            color={colors.primary[500]}
            children={t('sign_up_logistic_title')}
          />
        </div>
        <div className="mb-4 mt-4">
          <Toast
            variant="info"
            extended={true}
            style={{
              width: '100%',
              fontSize: 12,
            }}
          >
            {t('sign_up_logistic_toast_info')}
          </Toast>
        </div>
        <div className="mb-4">
          <FormSection
            label={t('sign_up_logistic_title1')}
            description={
              <div className="content-description">
                <div className="text-description">
                  <span>{t('sign_up_logistic_text1')}</span>
                </div>
              </div>
            }
          >
            <div className="row mb-8">
              <div className="col-12" style={{ display: 'flex', justifyContent: 'space-around' }}>
                <div style={{ width: '100%' }}>
                  <Input
                    name="nameNode"
                    value={formik.values.nameNode ? formik.values.nameNode : ''}
                    input-state={formik.touched.nameNode && formik.errors.nameNode ? 'error' : 'default'}
                    disabled={false}
                    onChange={formik.handleChange}
                    label-text={t('sign_up_logistic_label_namenode')}
                    feedback-text={formik.touched.nameNode && formik.errors.nameNode ? formik.errors.nameNode : ''}
                    onBlur={formik.handleBlur}
                    width="100%"
                    style={{
                      width: '100%',
                    }}
                    placeholder=""
                    maxLength={255}
                    onKeyPress={event => {
                      if (!allowAlphanumeric.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={event => {
                      if (!allowAlphanumeric.test(event.clipboardData.getData('Text'))) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
                <div className="tooltip-space">
                  <ToolTip msg={getMessageTooltip('sign_up_logistic_tolltip_namenode')} position="left" />
                </div>
              </div>
            </div>
            <div className="row mb-8 rows-margin-top">
              <div className="col-6">
                <Input
                  name="addressWarehouse"
                  value={formik.values.addressWarehouse ? formik.values.addressWarehouse : ''}
                  input-state={formik.touched.addressWarehouse && formik.errors.addressWarehouse ? 'error' : 'default'}
                  disabled={false}
                  onChange={formik.handleChange}
                  label-text={t('sign_up_logistic_label_address')}
                  feedback-text={
                    formik.touched.addressWarehouse && formik.errors.addressWarehouse
                      ? formik.errors.addressWarehouse
                      : ''
                  }
                  onBlur={formik.handleBlur}
                  width="100%"
                  placeholder=""
                  maxLength={255}
                  onKeyPress={event => {
                    if (!allowAlphanumeric.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={event => {
                    if (!allowAlphanumeric.test(event.clipboardData.getData('Text'))) {
                      event.preventDefault();
                    }
                  }}
                />
              </div>
              <div className="col-6" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Input
                  name="numberNode"
                  value={formik.values.numberNode ? formik.values.numberNode : ''}
                  input-state={formik.touched.numberNode && formik.errors.numberNode ? 'error' : 'default'}
                  disabled={false}
                  onChange={formik.handleChange}
                  label-text={t('sign_up_logistic_label_numbernode')}
                  feedback-text={formik.touched.numberNode && formik.errors.numberNode ? formik.errors.numberNode : ''}
                  onBlur={formik.handleBlur}
                  width="100%"
                  placeholder=""
                  maxLength={255}
                  onKeyPress={event => {
                    if (!allowAlphanumeric.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={event => {
                    if (!allowAlphanumeric.test(event.clipboardData.getData('Text'))) {
                      event.preventDefault();
                    }
                  }}
                />
                <div className="tooltip-space">
                  <ToolTip msg={getMessageTooltip('sign_up_logistic_tolltip_numbernode')} position="left" />
                </div>
              </div>
            </div>
            <div className="row  mb-8 rows-margin-top">
              <div className="col-6">
                <Dropdown
                  dropdown-options={optionsRegions}
                  disabled={false}
                  width="100%"
                  placeholder={t('sign_up_logistic_label_region')}
                  default-value={formik.values.regionWarehouse ? formik.values.regionWarehouse : ''}
                  onChange={value => setRegion(value)}
                  variant={formik.touched.regionWarehouse && formik.errors.regionWarehouse ? 'error' : 'default'}
                  text-feedback={
                    formik.touched.regionWarehouse && formik.errors.regionWarehouse ? formik.errors.regionWarehouse : ''
                  }
                />
              </div>
              <div className="col-6">
                {optionsCommune && optionsCommune.length > 0 ? (
                  <Dropdown
                    dropdown-options={optionsCommune}
                    disabled={false}
                    width="100%"
                    placeholder={t('sign_up_logistic_label_commune')}
                    default-value={formik.values.communeWarehouse ? formik.values.communeWarehouse : ''}
                    onChange={value => {
                      formik.setFieldValue('communeWarehouse', value);
                      const dataComune = optionsCommune.find(item => item.value === value);
                      if (dataComune) {
                        formik.setFieldValue('nameComune', dataComune.label);
                      }
                    }}
                    variant={formik.touched.communeWarehouse && formik.errors.communeWarehouse ? 'error' : 'default'}
                    text-feedback={
                      formik.touched.communeWarehouse && formik.errors.communeWarehouse
                        ? formik.errors.communeWarehouse
                        : ''
                    }
                  />
                ) : null}
              </div>
              <div className="col-6" />
            </div>
          </FormSection>
        </div>
        <div>
          <FormSection
            label={t('sign_up_logistic_title2')}
            description={
              <div className="content-description">
                <div className="text-description">
                  <span>{t('sign_up_logistic_text2')}</span>
                </div>
              </div>
            }
          >
            <div className="row  mb-8">
              <div className="col-6">
                <div className="label-rut">
                  <Input
                    name="nameContact"
                    value={formik.values.nameContact ? formik.values.nameContact : ''}
                    input-state={formik.touched.nameContact && formik.errors.nameContact ? 'error' : 'default'}
                    disabled={false}
                    onChange={formik.handleChange}
                    label-text={t('sign_up_logistic_label_name')}
                    feedback-text={
                      formik.touched.nameContact && formik.errors.nameContact ? formik.errors.nameContact : ''
                    }
                    onBlur={formik.handleBlur}
                    width="100%"
                    placeholder=""
                    maxLength={50}
                    onKeyPress={event => {
                      if (!allowAplphabetic.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={event => {
                      if (!allowAplphabetic.test(event.clipboardData.getData('Text'))) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-6">
                <Input
                  name="lastnameContact"
                  value={formik.values.lastnameContact ? formik.values.lastnameContact : ''}
                  input-state={formik.touched.lastnameContact && formik.errors.lastnameContact ? 'error' : 'default'}
                  disabled={false}
                  onChange={formik.handleChange}
                  label-text={t('sign_up_logistic_label_lastname')}
                  feedback-text={
                    formik.touched.lastnameContact && formik.errors.lastnameContact ? formik.errors.lastnameContact : ''
                  }
                  onBlur={formik.handleBlur}
                  width="100%"
                  placeholder=""
                  maxLength={50}
                  onKeyPress={event => {
                    if (!allowAplphabetic.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={event => {
                    if (!allowAplphabetic.test(event.clipboardData.getData('Text'))) {
                      event.preventDefault();
                    }
                  }}
                />
              </div>
            </div>
            <div className="row  mb-8 rows-margin-top">
              <div className="col-6">
                <Input
                  name="emailWarehouse"
                  value={formik.values.emailWarehouse ? formik.values.emailWarehouse : ''}
                  input-state={formik.touched.emailWarehouse && formik.errors.emailWarehouse ? 'error' : 'default'}
                  disabled={false}
                  onChange={formik.handleChange}
                  label-text={t('sign_up_logistic_label_email')}
                  feedback-text={
                    formik.touched.emailWarehouse && formik.errors.emailWarehouse ? formik.errors.emailWarehouse : ''
                  }
                  onBlur={formik.handleBlur}
                  width="100%"
                  placeholder=""
                  maxLength={100}
                  onKeyPress={event => {
                    if (!allowEmail.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={event => {
                    if (!allowEmail.test(event.clipboardData.getData('Text'))) {
                      event.preventDefault();
                    }
                  }}
                />
              </div>
              <div className="col-6">
                <Input
                  name="emailConfirmWarehouse"
                  value={formik.values.emailConfirmWarehouse ? formik.values.emailConfirmWarehouse : ''}
                  input-state={
                    formik.touched.emailConfirmWarehouse && formik.errors.emailConfirmWarehouse ? 'error' : 'default'
                  }
                  disabled={false}
                  onChange={formik.handleChange}
                  label-text={t('sign_up_logistic_label_confirm_email')}
                  feedback-text={
                    formik.touched.emailConfirmWarehouse && formik.errors.emailConfirmWarehouse
                      ? formik.errors.emailConfirmWarehouse
                      : ''
                  }
                  onBlur={formik.handleBlur}
                  width="100%"
                  placeholder=""
                  maxLength={100}
                  onKeyPress={event => {
                    if (!allowEmail.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={event => {
                    if (!allowEmail.test(event.clipboardData.getData('Text'))) {
                      event.preventDefault();
                    }
                  }}
                />
              </div>
            </div>
            <div className="row  mb-8 rows-margin-top">
              <div className="col-6">
                <Input
                  name="rolWarehouse"
                  value={formik.values.rolWarehouse ? formik.values.rolWarehouse : ''}
                  input-state={formik.touched.rolWarehouse && formik.errors.rolWarehouse ? 'error' : 'default'}
                  disabled={false}
                  onChange={formik.handleChange}
                  label-text={t('sign_up_logistic_label_rol')}
                  feedback-text={
                    formik.touched.rolWarehouse && formik.errors.rolWarehouse ? formik.errors.rolWarehouse : ''
                  }
                  onBlur={formik.handleBlur}
                  width="100%"
                  placeholder=""
                  maxLength={50}
                  onKeyPress={event => {
                    if (!allowAlphanumeric.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={event => {
                    if (!allowAlphanumeric.test(event.clipboardData.getData('Text'))) {
                      event.preventDefault();
                    }
                  }}
                />
              </div>
              <div className="col-6">
                <div className="label-rut">
                  <div className="phone-area">
                    <Typography typeElement="body1" weight="regular" color="#212C39" children={t('phone_area')} />
                  </div>
                  <Input
                    name="phoneWarehouse"
                    maxLength={9}
                    value={formik.values.phoneWarehouse ? formik.values.phoneWarehouse : ''}
                    input-state={formik.touched.phoneWarehouse && formik.errors.phoneWarehouse ? 'error' : 'default'}
                    disabled={false}
                    onChange={formik.handleChange}
                    label-text={t('sign_up_logistic_label_phone')}
                    feedback-text={
                      formik.touched.phoneWarehouse && formik.errors.phoneWarehouse ? formik.errors.phoneWarehouse : ''
                    }
                    onBlur={formik.handleBlur}
                    width="323px"
                    placeholder=""
                    onKeyPress={event => {
                      if (!allownumber.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={event => {
                      if (!allownumber.test(event.clipboardData.getData('Text'))) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <div className="tooltip-space">
                    <ToolTip msg={getMessageTooltip('phone_information')} position="top-left" />
                  </div>
                </div>
              </div>
            </div>
          </FormSection>
        </div>
        <div>
          <FormSection label={t('sign_up_logistic_title3')} description={<div />}>
            <div className="row">
              <div className="col" />
              <div className="col-auto container-toggle">
                <Toggle
                  onChange={value => formik.setFieldValue('technicalService', value.state)}
                  active={formik.values.technicalService ? formik.values.technicalService : false}
                  size="s"
                  text={t('sign_up_logistic_label_toggle')}
                  disabled={false}
                />
              </div>
            </div>
          </FormSection>
        </div>
      </div>
      <BottomBar onBack={() => handleOnBack()} onNext={() => handleOnNext()} />
    </>
  );
};

export default LogisticStep;
